module.exports = __webpack_public_path__ + "img/icon-Help-gray.a6d6a062.png";